/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import { useParams } from "react-router-dom";
import OtrosVehiculosComponent from "../components/vehiculos-detail/otros-vehiculos.component";

const CitaTallerPage: React.FC = () => {
  const { category } = useParams<{ category?: string }>();
  const [visibleHeight, setVisibleHeight] = useState(0);

  useEffect(() => {
    /* lastNewsforCategories().then(function (res: any) {
      let posts: any = [];
      res?.data?.data[0].Categories.forEach((element: any) => {
        element.posts.forEach((pos: any) => {
          pos.category_id = element.category_id;
          pos.category = element.category;
          posts.push(pos);
        });
      });
      
      // Ordenar los posts por fecha de creación de forma descendente
      const sortedPosts = posts.sort((a: any, b: any) => new Date(b.creation_datetime).getTime() - new Date(a.creation_datetime).getTime());
      
      // Obtener los 4 más recientes
      setNewsForCategories(sortedPosts.slice(0, 4));
      setOpportunities(res?.data?.data[0].Opportunities)
    }); */
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <div className="home-page-mascara"></div>
        <iframe
          src="https://citastaller.hyundaicolombia.co"
          style={{ position: "absolute", display: "initial", border: "0" }}
          className="iframe-cita"
          allowFullScreen
          title="taller"
          width="100%"
          height="100%"
        ></iframe>
        {/* <OtrosVehiculosComponent /> */}
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      {/* <FooterLayouts /> */}
    </>
  );
};

export default CitaTallerPage;
